if (!customElements.get('component-pdp-loyalty-banner')) {
  customElements.define('component-pdp-loyalty-banner', class PDPLoyaltyBanner extends HTMLElement {
    constructor() {
      super();
      this.props = {
        multiplier: this.dataset.multiplier
      };
      this.dom = {
        banner: this.querySelector('.desc span')
      };
    }

    connectedCallback() {
      document.addEventListener('pdp-loyalty-banner-updated', this.updatePointsListener.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener('pdp-loyalty-banner-updated', this.updatePointsListener);
    }

    updatePointsListener(evt) {
      if (!evt.detail.price) return;
      const points = Math.floor(evt.detail.price / 100) * this.props.multiplier;
      this.dom.banner.textContent = `Earn ${points} points`;
    }
  })
}
